<!--
 * @Description:
 * @Date: 2021-03-21 20:31:25
-->
<template>
  <BaseLayoutMain
    :class="{
      'layout-main': !hideBreadcrumb,
      'layout-main-not': hideBreadcrumb
    }"
    appName="营销服务SAAS业务平台"
    :menuType="menuType"
    :hideBreadcrumb="hideBreadcrumb"
    :menus="menus"
    :breadcrumbData="breadcrumbData"
    :renderMenuTop="renderMenuTop"
    :hide-menu="hideMenu"
    @menuClick="onMenuClick"
  >
    <!-- 项目中心-项目详情特殊处理 -->
    <template v-if="isProjectDetail" #bodyTop>
      <div style="display: flex; align-items: center; height: 100%">
        <ProjectCenterEditHeader
          :sceneName="projectInfo?.sceneName"
          :projectName="projectInfo?.projectName"
          :projectCode="projectInfo?.projectCode"
        ></ProjectCenterEditHeader>
      </div>
    </template>

    <template #headerLeft>
      <base-svg iconClass="logo_home" style="font-size: 200px"></base-svg>
    </template>

    <template #headerRight>
      <div style="height: 100%; display: flex; align-items: center">
        <layout-toolbar />
      </div>
    </template>
    <router-transition />
    <!-- qiankun: 子应用容器 -->
    <div id="subapp-container"></div>
  </BaseLayoutMain>
</template>
<script lang="tsx" setup>
import LayoutToolbar from './components/toolbar/index.vue';
import { RouterTransition } from '@/components/transition/index';
import { computed, toRefs } from 'vue';
import { BaseLayoutMain, BaseLayoutMenuProps } from 'xrk-components';

import { storeToRefs } from 'pinia';
import { RouteLocationNormalizedLoaded, useRoute, useRouter } from 'vue-router';
import appStore from '@/store';
import ProjectCenterEditHeader from '@/views/project-center-edit/src/components/project-center-edit-header.vue';
import { useProject } from './hooks/useProject';

const router = useRouter();
const route = useRoute();

const {
  projectInfo,
  isProjectDetail,
  clearProjectManageStore,
  projectHideMenu
} = useProject();

const _findFirstUrl = menu => {
  if (!menu.menuList?.length) {
    return menu.url;
  } else {
    return _findFirstUrl(menu.menuList[0]);
  }
};
const { onMenuClick, menus, menuUrls } = (() => {
  const { menus, menuUrls } = storeToRefs(appStore.useMenuStoreSetup);

  const onMenuClick = async (menu: BaseLayoutMenuProps['menus'][0]) => {
    // 清除项目中心搜索缓存数据
    if (!isProjectDetail.value) await clearProjectManageStore();

    if (menu.menuList?.length) {
      if (menuType.value === 'horizontal') router.push(_findFirstUrl(menu));
      return;
    }

    router.push(menu.url);
  };

  return { onMenuClick, menus, menuUrls };
})();

// 是否隐藏菜单
const hideMenu = computed(() => {
  // 项目详情，隐藏菜单逻辑特殊处理
  if (isProjectDetail.value) return projectHideMenu();

  return false;
});

// 横向菜单处理
const menuType = computed(() => {
  return menus.value.some(menu => +menu.resourceType === 4)
    ? 'horizontal'
    : 'vertical';
});

// 是否隐藏面包屑
const hideBreadcrumb = computed(() => {
  // 项目详情需要展示面包屑，特殊处理
  if (isProjectDetail.value) return false;

  return menuType.value === 'horizontal';
});

/**
 * @description: 横向菜单，一级菜单处理
 * @returns {*}
 */
const renderMenuTop = () => {
  // 项目中心-编辑项目特殊处理
  if (isProjectDetail.value) return <div></div>;
};

const { menuParentInfo } = toRefs<{ menuParentInfo: Map<string, any> }>(
  appStore.useMenuStoreSetup
);
const breadcrumbFormat = path =>
  (menuParentInfo.value.get?.(path) || []).map(item => {
    return {
      name: item.name,
      ...(menuUrls.value.includes(item.url) && { to: item.url, replace: true })
    };
  });

const findParentPath = (matched: RouteLocationNormalizedLoaded['matched']) => {
  let path = '';
  for (let i = matched.length - 1; i > 0; i--) {
    if (!matched[i].meta.parentPath) {
      path = matched[i].path;
      break;
    }
  }
  return path;
};

const breadcrumbData = computed(() => {
  const { path, meta } = route;
  if (meta.parentPath) {
    // route: 平级情况下不能通过matched遍历出子集，因为list与detail是平级
    const parentPath = (meta.parentPath ??
      findParentPath(route.matched || [])) as string;
    return [...breadcrumbFormat(parentPath), { name: route.meta.title }];
  }
  return breadcrumbFormat(path);
});
</script>

<style lang="scss" scoped>
.layout-main {
  ::v-deep {
    .body-top {
      min-height: 32px !important;
    }
  }
}
.layout-main-not {
  ::v-deep {
    .body-top {
      min-height: 20px !important;
    }
  }
}
::v-deep {
  .xrk-collapse {
    border-top: none;
  }
  .main-menu {
    border-top: 1px solid #eaebed;
  }
}
</style>
